import "./dispatch-error-modal.css";

import { SvgIcon } from "@tql/ui-components-react/kendo/common";
import { alertTriangle } from "@tql/ui-components-react/untitled/icons";
import { format } from "date-fns";

import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const DispatchErrorModal = ({
	onClose,
	isOpen,
	attemptedAt,
	errorMessage,
}: {
	onClose: () => void;
	isOpen: boolean;
	attemptedAt: Date | null;
	errorMessage: string | null | undefined;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			cancelText={"Close"}
			className={"dispatch-error-modal"}
			onCancel={onClose}
			onClose={onClose}
			showConfirmButton={false}
			showConfirmationButtons={true}
			title={"Dispatch Error"}
			type={"error"}
		>
			<div>
				<SvgIcon
					icon={alertTriangle}
					size={"xxxlarge"}
					style={{ color: "var(--kendo-color-error)" }}
				/>
				<span>
					<span>
						Dispatch could not be completed. Attempted on{" "}
						{attemptedAt ? format(attemptedAt, "M/d/yyyy, hh:mm a") : "N/A"}
					</span>
					<span>Error: {errorMessage ?? "N/A"}</span>
				</span>
			</div>
		</TraxModal>
	);
};
